<!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
_/                                                                                                                    _/
_/      子画面定義：ファイルエクスポート画面(STDSDC01C06)                                                             _/
_/                                                                                                                    _/
_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/ -->
<template>
  <BaseModal :show="isExportShow">
    <div class="popup" style="width: 650px">
      <div class="popup-head">エクスポート</div>
      <div class="popup-body blue">
        <!-- ****  メッセージ表示領域 **** -->
        <p class="errMsg title-ico ico-warning" v-show="errors != ''">
          <ErrorMessage isModalError :errors="errors"></ErrorMessage>
        </p>
        <p class="newline">{{ message }}</p>
        <hr />
        <div class="frm-row">
          <span class="frm-label w-140px">
            <strong v-if="this.pageId == 'STDSDC04C01'">出力形式</strong>
            <strong v-else>ファイルの種類</strong>
          </span>
          <div
            ref="toggleBtn"
            style="width: fit-content"
            class="frm-toggle"
            tabindex="1"
            @keydown.left.stop.prevent="toggleRadio"
            @keydown.right.stop.prevent="toggleRadio"
          >
            <label>
              <input
                ref="excelButton"
                type="radio"
                name="fileKind"
                v-model="fileKind"
                tabindex="-1"
                value="0"
                :checked="fileKind == 0"
                @change="handleChange"
              />
              <span v-if="this.pageId == 'STDSDC04C01'">申告書単位</span>
              <span v-else>Excel</span>
            </label>
            <label>
              <input
                type="radio"
                name="fileKind"
                v-model="fileKind"
                tabindex="-1"
                value="1"
                :checked="fileKind == 1"
                @change="handleChange"
              />
              <span v-if="this.pageId == 'STDSDC04C01'">収集書類単位</span>
              <span v-else>CSV</span>
            </label>
          </div>
        </div>
        <br />
        <div class="frm-btn-row footer-btn">
          <div class="frm-item grow center">
            <button
              class="frm-btn strong large"
              @click="handleOutput"
              :disabled="isDisabled"
              tabindex="2"
            >
              エクスポート
            </button>
            <button class="frm-btn large" tabindex="3" @click="handleCancel">
              キャンセル
            </button>
          </div>
        </div>
      </div>
    </div>
  </BaseModal>
</template>
<script>
import _ from "lodash";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import Common from "@/util/common.js";
import ErrorMessage from "@/components/ErrorMessage.vue";
import BaseModal from "@/components/Base/BaseModal.vue";
import { downLoadApi } from "@/api/common_download";
import { API_Export } from "@/api/Modules/DC01/STDSDC01C06.js";

export default {
  name: "FileExportModal",
  components: {
    ErrorMessage,
    BaseModal,
  },
  props: {
    pageId: {
      type: String,
      required: true,
    },
    dateFrom: {
      type: String,
      default: "",
    },
    dateTo: {
      type: String,
      default: "",
    },
    taxFilingDataId: {
      type: Number,
      default: 0,
    },

  },
  data() {
    return {
      fileKind: 0,
      errors: [],
      message: "",
      messageBop: "\n ※全ての情報が出力されます。",
      messageDoc: "",
      messageData: "\n ※指定した処理日時の情報が全て出力されます。",
      exportName: "",
      isDisabled: false, // エクスポートボタン_活性状態
    };
  },
  created() {
    this.errors = [];

    if (_.eq(this.pageId, "STDSDC04C01")) {
      this.message = Common.getMessage("MTCL2092", [
        Common.getSettingsValue("MaxExpCollectedDoc"),
      ]);
    }
    if (_.eq(this.pageId, "STDSDC02C01") || _.eq(this.pageId, "STDSCM02C02")) {
      this.exportName = "事業者情報";
      this.message = Common.getMessage("MTCL2061", [
        this.exportName,
        this.messageBop,
      ]);
    } else if (
      ["STDSDC02C10", "STDSDR02C02", "STDSCM02C11"].includes(this.pageId)
    ) {
      this.exportName = "社員情報";
      this.message = Common.getMessage("MTCL2061", [this.exportName, ""]);
    }

    if (_.eq(this.pageId, "STDSDC03C05")) {
      this.exportName = "収集書類情報";
      this.message = Common.getMessage("MTCL2061", [
        this.exportName,
        this.messageDoc,
      ]);
    }

    if (_.eq(this.pageId, "STDSDC05C09")) {
      this.exportName = "操作履歴情報";
      this.message = Common.getMessage("MTCL2061", [
        this.exportName,
        this.messageData,
      ]);
    } else if (_.eq(this.pageId, "STDSDC05C08")) {
      this.exportName = "ログイン履歴情報";
      this.message = Common.getMessage("MTCL2061", [
        this.exportName,
        this.messageData,
      ]);
    }
  },
  computed: {
    ...mapState("businessModule", ["exportFlag"]),
    ...mapGetters("businessModule", ["isExportShow"]),
  },
  watch: {
    exportFlag: function (newVal) {
      if (newVal) {
        this.$nextTick(function () {
          this.initFocus();
        });
      }
    },
  },
  methods: {
    ...mapMutations("businessModule", [
      "exportDialogue",
      "completeDialogue",
      "processDialogue",
    ]),
    ...mapActions("businessModule", ["showProcessDialogue"]),
    toggleRadio() {
      const oldValue = _.cloneDeep(this.fileKind);
      this.fileKind = this.fileKind == 0 ? 1 : 0;
      const focusableRadios = this.$refs.toggleBtn.querySelectorAll(
        'span[tabindex]:not([tabindex="-1"])'
      );
      const el = [...focusableRadios][oldValue];
      el?.focus();
    },
    // **********************************************
    //  選択されたファイルの種類
    // **********************************************
    handleChange(e) {
      this.fileKind = e.target.value;
    },
    // **********************************************
    //  エクスポートボタンをクリック
    // **********************************************
    handleOutput() {
      let param = {
        FileKind: this.fileKind,
        PageId: this.pageId,
        TaxFilingDataId: this.taxFilingDataId,
        DateFrom: this.dateFrom,
        DateTo: this.dateTo,
      };

      // エクスポートボタン　非活性化
      this.isDisabled = true;
      this.processDialogue(true);
      API_Export(param)
        .then(async (response) => {
          this.processDialogue(false);
          this.errors = [];
          //正常の場合
          if (_.eq(response.result, "0000")) {
            const result = await downLoadApi(
              response.exportFileName,
              response.uniqueKey,
              response
            );
            if (_.eq(result.result, "0000")) {
              // 「処理完了画面」表示
              // this.completeDialogue(true);
              // 画面を非表示にする
              this.exportDialogue(false);
            } else {
              if (_.eq(result.errorCD, "MTCL0999")) {
                // 各種エラー画面に遷移
                this.$router.push({
                  name: "STDSCM04C06",
                  state: {
                    message: Common.getMessage("MTCL0999", []),
                  },
                });
              } else {
                //上記以外の場合
                this.errors.push(
                  Common.createError(
                    result.errorCD,
                    Common.getMessage(result.errorCD, [])
                  )
                );
              }
            }
          } else {
            if (_.eq(response.errorCD, "MTCL0999")) {
              // 各種エラー画面に遷移
              this.$router.push({
                name: "STDSCM04C06",
                state: {
                  message: Common.getMessage("MTCL0999", []),
                },
              });
            } else if (_.eq(response.errorCD, "MTCL1169")) {
              //上記以外の場合
              this.errors.push(
                Common.createError(
                  response.errorCD,
                  Common.getMessage(response.errorCD, response.errorName)
                )
              );
            } else {
              //上記以外の場合
              this.errors.push(
                Common.createError(
                  response.errorCD,
                  Common.getMessage(response.errorCD, [])
                )
              );
            }
          }
          // エクスポートボタン　活性化
          this.isDisabled = false;
        })
        .catch(() => {
          this.processDialogue(false);
        });
    },
    // **********************************************
    // キャンセルボタンをクリック
    // **********************************************
    handleCancel() {
      this.errors = [];
      this.exportDialogue(false);
    },
    // **********************************************
    // 初期フォーカス設定
    // **********************************************
    initFocus() {
      this.$refs.toggleBtn.focus();
    },
  },
};
</script>
